import { APP_INITIALIZER, Provider } from '@angular/core';
import {
  BsDatepickerContainerComponent,
  BsDatepickerInlineContainerComponent,
  BsDaterangepickerContainerComponent
} from 'ngx-bootstrap/datepicker';
import { PositioningService } from 'ngx-bootstrap/positioning';

/**
 * Workaround for ngx-bootstrap PositioningService conflict.
 * Uses Angular private API (ɵcmp/providersResolver).
 * Verify after Angular or ngx-bootstrap upgrades.
 */
function patchContainer(containerClass: any): void {
  const cmpDef = containerClass?.['ɵcmp'];
  if (!cmpDef?.providersResolver) return;

  const original = cmpDef.providersResolver;
  cmpDef.providersResolver = (def: any, processProvidersFn?: (p: any[]) => any[]) =>
    original(def, (providers: any[]) => {
      const filtered = providers.filter(p => p !== PositioningService);
      return processProvidersFn ? processProvidersFn(filtered) : filtered;
    });
}

function patchBsDatepickerPositioning(): void {
  patchContainer(BsDatepickerContainerComponent);
  patchContainer(BsDatepickerInlineContainerComponent);
  patchContainer(BsDaterangepickerContainerComponent);
}

export const BS_DATEPICKER_POSITIONING_PATCH: Provider = {
  provide: APP_INITIALIZER,
  useValue: patchBsDatepickerPositioning,
  multi: true
};
